import { useEffect } from 'react';
import useUser from '@/hooks/useUser.js';
import { usePostHog } from 'posthog-js/react';
import useLoadUser from '@/hooks/useLoadUser.js';

const PostHogStateHandler = () => {
  const { isLoggedIn } = useLoadUser();
  const user = useUser();
  const posthog = usePostHog();

  // Identify the user with PostHog
  useEffect(() => {
    if (isLoggedIn && user?.jwt?.id && !posthog._isIdentified()) {
      posthog.identify(user?.jwt?.id, {
        email: user.jwt.email,
        username: user.jwt.name,
        companyId: user.jwt.companyId
      });
    }

    if (!isLoggedIn && posthog._isIdentified()) {
      posthog.reset();
    }
  }, [posthog, user]);

  return null;
};

export default PostHogStateHandler;
